/**
 * Official NormaX Performance Intelligence support contact — single source
 * of truth, imported by both LoginPage and SettingsPage so the address can
 * never drift between the two places it's shown
 * (docs/NORMAX_PERFORMANCE_PWA_AND_BRANDING_IMPLEMENTATION_REPORT.md §10).
 * Production-neutral: not a specific client's contact, just NormaX's own.
 */
export const SUPPORT_EMAIL = "support@normax.rs";
